"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgEmail(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M20 2v12H4V2zm-2 3.17l-6.02 5.147L6 5.178V12h12zM16.29 4H7.698l4.286 3.683z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Email')(SvgEmail);
//# sourceMappingURL=Email.js.map